class ManagerAsEmployeeCalendarController {
  constructor($stateParams) {
    'ngInject';
    this.userInceptionId = $stateParams.employeeId;
  }
}

export default ManagerAsEmployeeCalendarController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/managerAsEmployeeCalendar/managerAsEmployeeCalendar.controller.js